import { Component, Input } from '@angular/core';
import { SharedService } from '@ems/shared';
import { emtrConstant } from '../../constants/emtrConstants';

@Component({
  selector: 'tr-review-security-type',
  templateUrl: './review-security-type.component.html',
  styleUrls: ['./review-security-type.component.scss']
})
export class ReviewSecurityTypeComponent {
  readonly emtrConstant = emtrConstant;
  readonly title = emtrConstant.reviewSecurityType.title;
  readonly modalId = 'review-security-type-details-modal';

  @Input() selectedValues: any = {};
  @Input() formData: any;

  constructor(public sharedService: SharedService) {
  }

  openModal(event: Event): void {
    event.stopPropagation();
    this.sharedService.openModal(this.modalId);
  }

  closeModal(): void {
    this.sharedService.closeModal(this.modalId);
  }

  subTitleOverrideAndRestriction() {
    const isRestriction = this.formData?.rulesCategory === this.emtrConstant.rulesConstant.autoComplete.RESTRICT_LST_ENGTxt;
    const isOverride = this.formData?.override === 'Y';

    return (isRestriction && !isOverride)
      ? this.emtrConstant.reviewSecurityType.subTitleRestriction
      : this.emtrConstant.reviewSecurityType.subTitleOverride;
  }
}
